/**
 * The Book screen's states around its lists: loading, a failed read, the
 * studio's pause on new sessions, and each tab's empty state. Shared by the
 * app's Book screen and the website's phone Book screen, so neither reaches
 * the other's reads.
 */
import { EmptyBlock } from '@/components/client/EmptyBlock/EmptyBlock';
import styles from './BookSessionPage.module.css';

export function CatalogSkeleton() {
  return (
    <div className={styles.servicesList} data-testid="catalog-skeleton">
      <div className={styles.skeletonCard} />
      <div className={styles.skeletonCard} />
      <div className={styles.skeletonCard} />
    </div>
  );
}

export function CatalogError({ onRetry }: { onRetry: () => void }) {
  return (
    <div className={styles.stateBlock} data-testid="catalog-error">
      Couldn’t load this list.
      <div>
        <button type="button" className={styles.retryBtn} onClick={onRetry}>
          Try again
        </button>
      </div>
    </div>
  );
}

export function BookingsPausedNotice() {
  return (
    <div className={styles.closed} role="status">
      <span className={styles.closedIcon}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <rect x="6" y="4" width="4" height="16" rx="1" />
          <rect x="14" y="4" width="4" height="16" rx="1" />
        </svg>
      </span>
      <div>
        <div className={styles.closedTitle}>Not taking new session bookings right now</div>
        <div className={styles.closedSubtitle}>Check back soon.</div>
      </div>
    </div>
  );
}

/** Both tabs always show; an empty one says what will show up there (Gabriel 2026-10-21). */
export function NoServices() {
  return <EmptyBlock title="No services yet" sub="Services available for booking will show up here." />;
}

export function NoEvents() {
  return <EmptyBlock title="No events scheduled yet" sub="Scheduled events available for booking will show up here." />;
}
